import { render, staticRenderFns } from "./_DoExtLink.vue?vue&type=template&id=2132b6dd&scoped=true"
import script from "./_DoExtLink.vue?vue&type=script&lang=js"
export * from "./_DoExtLink.vue?vue&type=script&lang=js"
import style0 from "./_DoExtLink.vue?vue&type=style&index=0&id=2132b6dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132b6dd",
  null
  
)

export default component.exports